import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>ChapterChat</h3>
            <p>The social reading app for your bookshelf, your friends, and your next great read.</p>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms of Service</Link>
          </div>
          <div className="footer-section">
            <h4>Support</h4>
            <Link to="/support" className="footer-link">FAQ & Help</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 ShareSpace Apps. All rights reserved.</p>
          <p>Contact: <a href="mailto:admin@sharespaceapps.com">admin@sharespaceapps.com</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;